<template>
  <v-container grid-list-xl class="px-5">
    <m-card-list
      two-line
      title="Kelola Pemantau"
      search
      :add="true"
      :items="items"
      :headers="headers"
      refresh
      @refresh="load"
      :page="page"
      footer
      @search="search"
      @change:page="
            (pg) => {
              cp = pg
              load()
            }
          "
      @add="onAdd"
    >
      <template v-slot:items="{ props, item }">
        <tr>
          <td>
            {{ pVal(item, 'nama') }}
          </td>
          <td>{{ pVal(item, 'email') }}</td>
          <td>{{ pVal(item, 'jml_organisasi') }}</td>
          <td>
            <m-menu left style="float:right" :items="more_menu" :object="item" />
          </td>
        </tr>
      </template>
    </m-card-list>
    <ChangeDlg ref="formulir" @reload="load" />
    <ResetPass ref="reset" @reload="load" />
  </v-container>
</template>

<script>
export default {
  components: {
    BlockCard: () => import('@/components/BlockCard'),
    ChangeDlg: () => import('../components/Detail'),
    ResetPass: () => import('../components/ResetPemantau'),
  },
  data() {
    return {
      items: [],
      page: null,
      cp: 1,
      headers: [
        { text: 'Nama', align: 'left', value: 'nama' },
        { text: 'Surel', align: 'left', value: 'email' },
        { text: 'Jumlah Organisasi', align: 'left', value: 'jml_organisasi' },
        { text: 'Aksi', sortable: false },
      ],
      more_menu: [
        {
          title: 'Ubah',
          click: (i, o) => this.onEdit(o),
        },
        {
          title: 'Hapus',
          click: (i, o) => this.onDelete(o),
        },
        {
          title: 'Reset Password',
          click: (i, o) => this.onReset(o),
        },
      ],
      search: '',
    }
  },
  computed: {},
  created() {
    this.load()
  },
  methods: {
    load() {
      this.$store
        .dispatch('pemantau/get')
        .then((res) => {
          this.page = res.data
          this.items = res.data.data
        })
        .catch((e) => e)
    },
    onEdit(item) {
      this.$store.dispatch('pemantau/getDetail', { id: item.user_id }).then(({ data }) => {
        this.$refs.formulir.open(data)
      })
    },
    onAdd() {
      this.$refs.formulir.open({})
    },
    onDelete(item) {
      this.$confirmDanger(
        `
        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
         ${item.nama}<br>
        </div>

      `
      )
        .then(() => this.$store.dispatch('pemantau/drop', { id: item.user_id }))
        .then(() => {
          this.$info('Data berhasil dihapus')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
    onReset(item) {
      this.$refs.reset.open({ id: item.user_id })
    },
  },
}
</script>
